import axios from "axios";
import appointments from "../src/configurations/appointments";
const http = axios.create({
  /***************ATENTION!***************/
  //When changing deployment from production to homologation or vice-versa,
  //the baseURL needs to be corrected (in this archive),
  //but also in the package.json where homepage is the baseURL link (without /api) + "/UI"

  baseURL: appointments.baseURL,

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

//interceptor is used to update the token sent inside the header
http.interceptors.request.use(async (config) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem("token")}`;
  return config;
});

export default http;
